const domain = window.location.host.split('.').reverse()[1] === 'financhill' ?
	window.location.origin :
	'https://financhill.com';

export default function buildWidget(options) {
	const type = options.type || 'seasonality';
	const height = options.height || 400;
	const width = options.width || 720;

	let params = [];

	if (options.hideheader) {
		params.push('hideheader=1');
	}

	if (typeof options.custom === 'string') {
		options.custom = JSON.parse(options.custom);
	}

	const custom = (typeof options.custom === 'object' && options.custom) ? options.custom : {};

	//console.log("CUSTOM",custom)
	for (const key of Object.keys(custom)) {
		const value = custom[ key ];
		const param = value instanceof Array ? value.join(',') : value;

		if (param.length) {
			params.push(`${key}=${encodeURIComponent(param)}`);
		}
	}

	if (params.length) {
		params = `?${params.join('&')}`
	} else {
		params = '';
	}

	const html = `<iframe src="${domain}/widget/${type}/${options.symbol}${params}" width="${width}" height="${height}" frameborder="0" scrolling="no" style="margin:0 auto;border: 0;" seamless></iframe>`

	return html;
};
